import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PatientDocumentsUploadDialog } from '../../patient-documents-list/patient-documents-upload-dialog/patient-documents-upload-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { PatientDocumentService } from '../../patient-documents-list/patient-document-list.service';
import { MatTableDataSource } from '@angular/material/table';
import * as global from '../../global'
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { DialogConfirmationComponent } from '../../census-patient-list/dialog-confirmation/dialog-confirmation.component';


@Component({
  selector: 'app-pdf-scrubber',
  templateUrl: './pdf-scrubber.component.html',
  styleUrls: ['./pdf-scrubber.component.css']
})
export class PdfScrubberComponent implements OnInit {
  @Input() patient: any;
  patientDocuments = [];
  dataSource: any;
  files_length: number = 0;
  displayedColumns = ['document_title', 'uploaded_at', 'operations'];
  global = global;
  file_path: any;
  selectedText: string = '';
  selectedFileFormat: any;
  shouldShowPdf = false;
  pdfQuery = '';
  renderText = true;

  @ViewChild(PdfViewerComponent) private pdfComponent: PdfViewerComponent;
  @ViewChild('pdfViewer', { static: false }) pdfViewer!: PdfViewerComponent;
  selectedDocument: any = '';

  constructor(
    private dialog: MatDialog,
    private toastr: ToastrService,
    private authService: AuthService,
    private patientDocumentService: PatientDocumentService
  ) { }

  async ngOnInit() {
    await this.getPatientDocs();
  }

  async getPatientDocs() {
    const company_id = this.authService.currentUser.company_id;
    this.patientDocumentService.getPatientDocs(this.patient._id, company_id).subscribe((response: any) => {
      if (response.status === 200) {
        this.patientDocuments = response.data;
        this.getFileFormat(this.patientDocuments);
        console.log('patientDocuments', this.patientDocuments);
        this.dataSource = new MatTableDataSource(this.patientDocuments);
        this.files_length = this.patientDocuments?.length || 0;
      } else {
        this.toastr.error('Something went wrong please try again.');
      }
    }, () => { this.toastr.error('Something went wrong please try again.') }
    )
  }

  getFileFormat(docs) {
    if (docs.length > 0) {
      for (const doc of docs) {
        const lastIndexOfDot = doc.title.lastIndexOf('.')
        if (lastIndexOfDot >= 0) {
          doc.fileFormat = doc.title.substr(lastIndexOfDot + 1).toLowerCase();
        }
      }
    }
  }

  getItemIcon(title) {
    const extension = title.substr(title.lastIndexOf('.') + 1);
    const filetypeIconsPath = '../../../assets/img/filetypes';

    return (`${filetypeIconsPath}/${extension}.svg`);
  }

  showPatientsDialog() {
    const dialogRef = this.dialog.open(
      PatientDocumentsUploadDialog,
      { width: '80%', data: { patient: this.patient } }
    );
    dialogRef.beforeClosed().subscribe(async (fileInput: any) => {
      if (fileInput) {
        const [file] = fileInput.files;
        const infoToast = this.toastr.info('Uploading Document...', 'Please wait')
        const typeOfDocument = 'other';
        try {
          const company_id = this.authService.currentUser.company_id;
          this.patientDocumentService.uploadDocumentForScrubbing(file, this.patient._id, company_id, typeOfDocument).subscribe((response: any) => {
            if (response.data) {
              this.getPatientDocs();
              this.toastr.clear(infoToast.toastId);
              this.toastr.success('Uploaded Successfully','Success');
            }
            else {
              console.error(response.data.status, response.data.message);
              this.toastr.error(response.data.message, 'Failed');
            }
          });
        } catch (error) {
          this.toastr.error('Something went wrong please try again', 'Failed');

        } 
        // finally {
        //   this.toastr.clear(infoToast.toastId);
        //   this.toastr.success('Uploaded Successfully','Success');
        // }
      }
    });
  }

  tagText() {
    if (!this.selectedText) {
      this.toastr.warning('No text selected', 'Warning');
      return;
    }
    this.patientDocumentService.tagTextFromPdf(this.selectedDocument, this.patient._id, this.selectedText).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.toastr.success('Tagged Successfully','Success');
      }
    });
  }

  viewPDF(element, index?) {
    if (element.aws_path && element?.aws_path.includes("http")) {
      this.selectedFileFormat = element.fileFormat;
      this.file_path = element.aws_path;
      this.shouldShowPdf = !this.shouldShowPdf;

    } else {
      this.patientDocumentService.generateViewPdfUrl(element).subscribe((response: any) => {
        if (response.status === 200) {
          this.patientDocuments.forEach((doc) => {
            if (doc._id === element._id) {
              doc.aws_path = response.document.aws_path;
              doc.title = response.document.title;
              this.file_path = response.document.aws_path;
            }
          });
          this.getFileFormat(this.patientDocuments);
          this.selectedFileFormat = element.fileFormat;
          this.dataSource = new MatTableDataSource(this.patientDocuments);
          this.shouldShowPdf = !this.shouldShowPdf;
        } else {
          this.toastr.error('Something went wrong please try again.')
        }
      }, () => this.toastr.error('Something went wrong please try again.')
      )
    }
    this.selectedDocument = element._id;
    // this.shouldShowPdf = true;
    // this.file_path = element.aws_path;
  }

  deletePDF(document, index) {
    let dialogRef = this.dialog.open(DialogConfirmationComponent, {
      data: {
        message: 'Are you sure you want to delete?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === "true") {
        this.patientDocumentService.deletePatientDoc(document._id).subscribe((res:any)=> {
          if(res.status == 200) {
            this.toastr.success('Deleted Successfully','Success');
            this.deleteFromTable(index)
          }
        });
      }else return;
    });
  }

  deleteFromTable(index) {
    this.dataSource.data = [];
    this.patientDocuments.splice(index, 1);
    this.dataSource.data = this.patientDocuments;
    this.files_length--;
  }

  afterLoadComplete($event) {
    // console.log('$event',$event);
  }
  onError($event){
    // console.log($event); 
  }

  onProgress($event) { 
    // console.log('$event',$event);
  }
  pageRendered($event) {
    // console.log('$event',$event);
  }
  pageInitialized($event) {
    // console.log('$event',$event);
  }
  pageChange($event) {
    // console.log('$event',$event);
  }
  textLayerRendered(e: CustomEvent) {
    // console.log('(text-layer-rendered)', e);
  }
  captureSelectedText(event: MouseEvent): void {
    const selectedText = window.getSelection()?.toString();
    const selectedTextContainer = document.getElementById('selectedTextContainer');
    if (selectedText && selectedTextContainer) {
      selectedTextContainer.textContent = selectedText;
      this.selectedText = selectedText;
    }
  }
  searchQueryChanged(newQuery: string) {
    if (newQuery !== this.pdfQuery) {
      this.pdfQuery = newQuery;
      this.pdfComponent.pdfFindController.executeCommand('find', {
        query: this.pdfQuery,
        highlightAll: true
      });
    } else {
      this.pdfComponent.pdfFindController.executeCommand('findagain', {
        query: this.pdfQuery,
        highlightAll: true
      });
    }
  }
}
